module.exports = function() {
  return new Worker(__webpack_public_path__ + "670432eda33cf1010139.worker.js");
};